import type { FaireProductEntity } from "../../entity_types/product";

export const p_ghsxdz7myv: FaireProductEntity = {
  token: "p_ghsxdz7myv",
  type: "product",
  name: "Womens Plaid Shacket Oversized Button Down Jacket",
  brandToken: "b_axnmezu6gc",
  brandName: "Suhkasana",
  imageUrl:
    "https://cdn.faire.com/fastly/763b234bf61aa48c47845ba1e5d1cf11fae05d690797a7d8a68f56ea93c00f61.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc290de8eb0c5aec3a47b33792b8430788e2e7a6eb85b0983f718cef3e30b474.jpeg",
    "https://cdn.faire.com/fastly/116e2b99a7889dddbf09236619cb6e5ad733808fb3b27af885b15a33b71ea7cf.jpeg",
    "https://cdn.faire.com/fastly/418cb553310f47f24b275bb5f19fa02132dc2105b1ea422ec6ef0bf70767595a.jpeg",
    "https://cdn.faire.com/fastly/5fc64d90af8227d1b9601644c8846f043d65d4fc754f7bae0403c420f37cff5d.jpeg",
    "https://cdn.faire.com/fastly/98bca0b00500c7792de070f2af0d0f4529849becfa00478d6bb5d9b0916c3127.jpeg",
    "https://cdn.faire.com/fastly/c1338207f716e4230562701d3aab9989092953afb0d9da24c2762a691677859b.jpeg",
    "https://cdn.faire.com/fastly/7ad09af6f5c14ad860aa468add348fa24d0ac21448ebeb96936ef09a9306f8a1.jpeg",
    "https://cdn.faire.com/fastly/1a382f22770d46a113a1e65152704f9abf48c8d3e0259d9f7a2e76fe7d65690e.jpeg",
    "https://cdn.faire.com/fastly/8b6e189c75848e6355d7a13392757e9e528b556ec5d06986ef6980bc2bb5d76b.jpeg",
    "https://cdn.faire.com/fastly/e22ec1cc987b7d8e233b28c25af5183e150662060b261966a597454a980f5d75.jpeg",
    "https://cdn.faire.com/fastly/73b6ecb2f56dfa724d9257c578280cb5fc6b3cfe4df53fc4f435e13a7bf053c6.jpeg",
    "https://cdn.faire.com/fastly/95adddbe65521100b8f0c7925cd339b85d12b9641caa38ab23b759b8acc77652.jpeg",
    "https://cdn.faire.com/fastly/e9da341984ec43707853c90f8cc34f021665e97a9cfa3f46b1e60bd83aa03750.jpeg",
    "https://cdn.faire.com/fastly/8c7bdf6627c8c2473218307a7aa73cb5770fa241e1c9a3bb15333723d5d7584c.jpeg",
    "https://cdn.faire.com/fastly/ecd733689d79bc3f4e56904f9862ebe128945ea1c8e3307ad2d56a58cfc58359.jpeg",
    "https://cdn.faire.com/fastly/70e6821a13af0c58a026c27bc4d5e4f2efed41e5f84d7ee3156a3a2c53211b3f.jpeg",
    "https://cdn.faire.com/fastly/5918694cbb7135af7239650389eef2999260f10e98d9ee5fc48ab8b423c9cd8a.jpeg",
    "https://cdn.faire.com/fastly/51fb02ab367c7e830296536cbae2e9e28f69c309f3c8a4a7a20dbd54ad409c13.jpeg",
    "https://cdn.faire.com/fastly/3f9e090e14dd45427e73e7551033348c09aa9b404af3ecb165760e10fe3c0454.jpeg",
    "https://cdn.faire.com/fastly/bfcdc3eed4c51b2b78424dcb0d2eaf67f9ab435321c82636fa08adfe7ec4fffc.jpeg",
    "https://cdn.faire.com/fastly/786ce2b2de7876232593109f9b104628251ca57f4806288649f42d44ed81203e.jpeg",
    "https://cdn.faire.com/fastly/bab361a213c1fc92d96cfc1c3b66980b99c4fb1e88909c6ff1e3ef4228c282e8.jpeg",
    "https://cdn.faire.com/fastly/0d7e535c527c3a7a525bc48cc45e90c801ca2cf1fc9882c0a3b2f588d9d55f80.jpeg",
    "https://cdn.faire.com/fastly/2433f72e517a49c6ae3ccf78a1f73cf2e107c0ea0227ae41a673d6b339f07714.jpeg",
    "https://cdn.faire.com/fastly/985527274896552b286e06bf78ae346f5901a33891048f7cc6b10f141959da25.jpeg",
    "https://cdn.faire.com/fastly/e2a130739c59b769e8e1b1132411f988b12b73d3367a6419f93235817e2ca43e.jpeg",
    "https://cdn.faire.com/fastly/95e3b0606f5cfdd072a27d2a1b27bc5c715c30637abe8e07f436a3aa47850500.png",
  ],
  priceDollars: 79.12,
  description:
    "🚀 Ready to Ship / Expedited Shipping\n\nClassic plaid design featuring warm brown, black, and beige tones creates a timeless fall look that’s easy to style and perfect for layering all season.\n\nSoft and cozy brushed fabric keeps you comfortable and warm during chilly days while maintaining a lightweight feel for all-day wear.\n\nFunctional button-down front and flap chest pockets add a casual yet practical touch, blending utility and everyday style effortlessly.\n\nRelaxed oversized fit offers easy layering over tees or sweaters, making it a versatile outerwear piece for fall and winter outfits.\n\nPerfect for pairing with jeans, leggings, or boots for a trendy street look—ideal for daily wear, coffee runs, or cozy weekends out.",
  tags: [],
  msrpDollars: 158.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:51.363Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
